import {FC, useState} from 'react'
import {BaseModal} from '../../BaseModal/BaseModal'
import styles from './indexGrade.module.css'
import {CreateGrade} from './createGrade'
import {EditGrade} from './editGrad'
import {Button} from '../../../Button/Button'
import {i18n} from '../../../../translate/i18n'

type GridTypeResponse = {
  id: number
  name: string
  variation: string
  status?: boolean
}

type Props = {
  onCloseAction: () => void
  title: string
  grids: GridTypeResponse[]
  setGradeSelected: (grades: {variationId: number; variations: string[]}[]) => void
  gradeSelected: {variationId: number; variations: string[]}[]
  editGradeAgain?: boolean
  editPageProduct?: boolean
}

const IndexGrade: FC<Props> = ({
  onCloseAction,
  title,
  grids,
  gradeSelected,
  setGradeSelected,
  editGradeAgain = false,
  editPageProduct = false,
}) => {
  const [showCreateGrade, setShowCreateGrade] = useState(false)
  const [showEditGrade, setShowEditGrade] = useState(false)
  const [showAlert, setShowAlert] = useState(true)
  const [selectedGrade, setSelectedGrade] = useState<{
    variationId: number
    variations: string[]
  } | null>(null)

  const findNameGrade = (itemSelected: any) => {
    return grids.find((grade) => grade.id === itemSelected.variationId)?.name
  }

  return (
    <BaseModal
      onCloseAction={onCloseAction}
      title={title}
      disableClose={true}
      editPageProduct={editPageProduct}
    >
      {editGradeAgain && showAlert && (
        <div
          className='alert alert-warning position-relative'
          role='alert'
          style={{
            border: 'none',
            borderRadius: '6px',
            marginBottom: '1.5rem',
          }}
        >
          <button
            type='button'
            className='btn-close position-absolute'
            style={{
              top: '8px',
              right: '8px',
              padding: '0.25rem',
              fontSize: '0.55rem',
              opacity: '0.7',
            }}
            onClick={() => setShowAlert(false)}
            aria-label='Fechar'
          />
          <i className='fas fa-exclamation-triangle me-2'></i>
          Ao editar a grade, todas as variações configuradas anteriormente serão redefinidas.
        </div>
      )}
      {!editPageProduct && (
        <div className='d-flex justify-content-between align-items-center mb-4'>
          <div
            className='d-flex align-items-center gap-2'
            onClick={() => {
              setShowCreateGrade(true)
            }}
            style={{cursor: 'pointer'}}
          >
            <div className={styles.addButtonCircle}>
              <i className='fas fa-plus'></i>
            </div>
            <h2 className='m-0 fs-6' style={{color: '#009ef7'}}>
              Adicionar Grade
            </h2>
          </div>
        </div>
      )}
      {gradeSelected.length > 0 && (
        <div className={`${!editPageProduct && 'mt-6'} ${styles.gradeSelected}`}>
          {gradeSelected.map((grade) => (
            <div
              key={grade.variationId}
              className={`pb-8 ${styles.gradeSelectedItem}`}
              onClick={() => {
                setSelectedGrade(grade)
                setShowEditGrade(true)
              }}
            >
              <div className={styles.gradeSelectedItemContent}>
                <p className={`m-0 p-0 fs-6 ${styles.titleGradeSelectedItem}`}>
                  {findNameGrade(grade)}
                </p>
                <ul className='m-0 p-0 list-unstyled d-flex flex-wrap gap-1 pt-2'>
                  {grade.variations.map((variation) => (
                    <li className={`${styles.gradeVariationItem}`} key={variation}>
                      {variation}
                    </li>
                  ))}
                </ul>
              </div>
              <div className={`px-2 py-2 ${styles.arrowIcon}`}>
                <i className='fas fa-chevron-right'></i>
              </div>
            </div>
          ))}
        </div>
      )}
      <div className={styles.footer}>
        <Button
          text={i18n.t(`buttons.save`)}
          color='primary'
          size='small'
          horizontalPadding={5}
          btnAttr={{
            type: 'button',
          }}
          click={() => onCloseAction()}
          btnClass='fw-bolder'
        />
      </div>
      {showCreateGrade && (
        <CreateGrade
          onCloseAction={() => {
            setShowCreateGrade(false)
          }}
          title={'Adicionar Grade'}
          grids={grids}
          gradeSelected={gradeSelected}
          setGradeSelected={setGradeSelected}
        />
      )}
      {showEditGrade && selectedGrade && (
        <EditGrade
          onCloseAction={() => {
            setShowEditGrade(false)
            setSelectedGrade(null)
          }}
          title={'Editar Grade'}
          grids={grids}
          gradeSelected={gradeSelected}
          setGradeSelected={setGradeSelected}
          selectedGrade={selectedGrade}
          editPageProduct={editPageProduct}
        />
      )}
    </BaseModal>
  )
}

export {IndexGrade}
